import { useFetch } from "@/hooks/useFetch";
import { fetchGithubForProject } from "components/project/integration/api";

export const useGithubData = (id) => {
  const { data: githubData } = useFetch({
    queryKey: ["project-github-integrations", id],
    queryFn: () => fetchGithubForProject({ id: id }),
  });
  const githubRepos = Array.isArray(githubData)
    ? githubData
        .map((entry) => ({
          // git_repositories row: one id serves as both the route's service id and repo id.
          project_service_id: entry?.id,
          repository_url: entry?.repository_url,
          suffix: entry?.suffix,
          repo_id: entry?.id,
        }))
        .filter((repo) => Boolean(repo.repository_url))
    : [];

  return {
    githubData,
    githubRepos,
  };
};
